export default{
    data(){
        return{
            
        }
    },
   
    method:{
        
        
    },

    

}


// WEBPACK FOOTER //
// ./src/mixins/activePath.js